import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Spinner from "../Spinner.jsx";

const buttonCopy = {
  idle: "Save settings",
  loading: <Spinner size="sm" />,
  success: "Settings saved!",
};

export default function SaveBtn({
  onClickFn,
  isDisabled,
  completedFn = null,
  refProp = null,
  idleText = buttonCopy.idle,
  loadingText = buttonCopy.loading,
  successText = buttonCopy.success,
}) {
  const [buttonState, setButtonState] = useState("idle");
  const [copy, setCopy] = useState("");

  useEffect(() => {
    switch (buttonState) {
      case "loading":
        setCopy(loadingText)
        break;
      case "success":
        setCopy(successText)
        break;
      default:
        setCopy(idleText)
        break;
    }
  }, [buttonState, idleText, loadingText, successText])

  const handleClick = async () => {
    if (isDisabled || buttonState !== "idle") return;
    
    setButtonState("loading");

    await onClickFn()
    setButtonState("success");

    setTimeout(() => {
      setButtonState("idle");
      if (completedFn) completedFn();
    }, 2000);
  };

  const handleKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === " ") && (isDisabled || buttonState !== "idle")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <div className="outer-wrapper">
      <button
        ref={refProp ? refProp : null}
        className={`
          px-spacing-3 h-[32px] rounded text-dls-body transition-all
          duration-200 flex items-center justify-center 
          focus:outline-accent
          ${
            isDisabled
              ? 'bg-bg-active text-secondary cursor-not-allowed'
              : 'bg-accent text-tertiary hover:bg-hover'
          }`
        }
        disabled={buttonState !== "idle" || isDisabled}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        <AnimatePresence mode="popLayout" initial="idle">
          <motion.span
            className="w-full flex justify-center items-center"
            transition={{ type: "spring", duration: 0.2, bounce: 0 }}
            initial={{ opacity: 0, y: -25 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 25 }}
            key={buttonState}
          >
            <span>{copy}</span>
          </motion.span>
        </AnimatePresence>
      </button>
    </div>
  );
}
